import * as React from 'react';
import Grid from '@mui/material/Grid2';
import PricingStepSummary from './pricing-step-3';
import StandardTermsStep from './standardterms';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
interface ReviewFinalStepProps {
  detailForm: any;
  currentCustomer: any;
  currentProject: any;
  projectForm: any;
  fileQuoteMedia: any[];
  companyDetails: any;
  expandRowState: any[];
  billableFormItems: any[];
  projectTemplateList: any[];
  termsList: any[];
  selectedAdhocTerms: any[];
  selectedExclusions: any[];
  selectedQuoteInclusion: any;
  selectedQuoteExclusion: any;
  overheads: number;
  fileQuoteMediaCurrent: any[];
  projectPercentage: number;
  contigencyPercentage: number;
  projectMargin: number;
  GST: number;
  status: number;
  overheadPercent: number;
  induction: any[];
  currentStandardTermsList: any[];
  rejectReasonsListTxt: any[];
  fileDownloading: boolean;
  handleDownloadFile: (id: any) => void;
}
const ReviewFinalStep: React.FC<ReviewFinalStepProps> = ({
  detailForm,
  currentCustomer,
  currentProject,
  projectForm,
  fileQuoteMedia,
  companyDetails,
  expandRowState,
  billableFormItems,
  projectTemplateList,
  termsList,
  selectedAdhocTerms,
  selectedExclusions,
  selectedQuoteInclusion,
  selectedQuoteExclusion,
  overheadPercent,
  overheads,
  fileQuoteMediaCurrent,
  projectPercentage,
  GST,
  status,

  induction,
  currentStandardTermsList,
  contigencyPercentage,
  projectMargin,
  rejectReasonsListTxt,
  fileDownloading,
  handleDownloadFile,
}) => {
  return (
    <Grid container spacing={2} style={{ marginTop: '30px' }}>
      {/* Section Header */}
      <h1 className="form-label">{'Details'}</h1>
      <Grid size={12}>
        <h2 className="mt-4 mb-3">Quote Info</h2>
        <Grid container spacing={2}>
          <Grid size={4}>
            <h6 className="quote-form-label">{'Quote Status'}</h6>
            {status}
          </Grid>
          {(detailForm.quoteStatusId !== '5' ||
            detailForm.quoteStatusId !== '7') &&
            rejectReasonsListTxt.length > 0 && (
              <Grid size={8}>
                <h6 className="quote-form-label">{'Quote Reject Reason'}</h6>
                {rejectReasonsListTxt.toString()}
              </Grid>
            )}
        </Grid>
      </Grid>
      {/* Customer Sections */}
      <Grid size={12}>
        <h2 className="mt-4 mb-3">Customer Details</h2>
        <Grid container spacing={2}>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Customer'}</h6>
            {currentCustomer?.name}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Main Contact'}</h6>
            {detailForm.mainContact}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Customer Email'}</h6>
            {detailForm.customerEmail}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Main Contact Number'}</h6>
            {detailForm.contactNumber}
          </Grid>
        </Grid>
      </Grid>
      {/* Customer Sections  Ends*/}

      {/* Project Sections */}
      <Grid size={12}>
        <h2 className="mt-4 mb-3">Project Details</h2>
        <Grid container spacing={2}>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Project Name'}</h6>
            {detailForm.projectName}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Category of work'}</h6>
            {detailForm.projectWorkCategory}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Site Address'}</h6>
            {detailForm.projectSiteAddress}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Estimate Start Date'}</h6>
            {detailForm.estimateStartDate}
          </Grid>

          <Grid size={3}>
            <h6 className="quote-form-label">{'Quote Submission Due Date'}</h6>
            {detailForm.submissionDueDate}
          </Grid>
          <Grid size={3}>
            <h6 className="quote-form-label">{'Quote Valid To'}</h6>
            {detailForm.validToDate}
          </Grid>
          {induction && (
            <Grid size={3}>
              <h6 className="quote-form-label">{'Induction Required'}</h6>
              {induction.map((inductionData) => {
                return <Box>{inductionData.name}</Box>;
              })}
            </Grid>
          )}
          {currentProject && (
            <Grid size={3}>
              <h6 className="quote-form-label">{'Project Template'}</h6>
              {currentProject.name}
            </Grid>
          )}
          <Grid size={12}>
            <h6 className="quote-form-label">{'Notes'}</h6>
            {detailForm.internalNotes}
          </Grid>
        </Grid>
      </Grid>
      {/* Project Sections  Ends*/}

      {/* Document Sections */}
      <Grid size={12}>
        <h2 className="mt-4 mb-3">Documents</h2>
        <Grid container spacing={2}>
          {fileQuoteMedia.map((file) => {
            return (
              <Box
                style={{
                  backgroundColor: 'rgba(0, 244, 255, 0.08)',
                  color: '#000',
                  margin: '5px',
                  padding: '20px',
                  width: '450px',
                  cursor: 'pointer',
                }}
              >
                <div style={{ borderBottom: '5px solid black' }}>
                  {file.name}
                </div>
              </Box>
            );
          })}
          {fileQuoteMediaCurrent.map((file) => {
            return (
              <Box
                onClick={() => {
                  handleDownloadFile(file.id);
                }}
                style={{
                  backgroundColor: 'rgba(0, 244, 255, 0.08)',
                  color: '#000',
                  margin: '5px',
                  padding: '20px',
                  width: '450px',
                  cursor: 'pointer',
                  wordWrap: 'break-word',
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                }}
              >
                <Box
                  style={{
                    borderBottom: '5px solid black',
                    wordWrap: 'break-word',
                    width: '420px',
                  }}
                >
                  {file.name}
                </Box>
                <Box>
                  {fileDownloading === file.id ? (
                    <CircularProgress size={24} />
                  ) : (
                    <DownloadIcon />
                  )}
                </Box>
              </Box>
            );
          })}
        </Grid>
      </Grid>
      {/* Document Sections  Ends*/}

      {/* Pricing Sections */}
      <Grid size={12}>
        <h2 className="mt-4 mb-3">Pricing</h2>
        <Grid container spacing={2}>
          {currentProject && (
            <Grid size={12}>
              <h6 className="quote-form-label">{'Project Template'}</h6>
              {currentProject.name}
            </Grid>
          )}
          <Grid size={12}>
            <PricingStepSummary
              billableFormItems={billableFormItems}
              companyDetails={companyDetails}
              currentProject={currentProject}
              expandRowState={expandRowState}
              handleArrow={() => {}}
              handleAutoCompleteChange={() => {}}
              handleBillableDetailChange={() => {}}
              handleBillableDialog={() => {}}
              handleResourceDialog={() => {}}
              projectForm={projectForm}
              projectTemplateList={projectTemplateList}
              removeDetailsItem={() => {}}
              handleOverHeadPercentage={() => {}}
              removeItem={() => {}}
              viewOnly={true}
              overheads={overheads}
              overheadPercentage={overheadPercent}
              handleOverHeads={() => {}}
              projectPercentage={projectPercentage}
              handleProjectMargin={() => {}}
              contigencyPercentage={contigencyPercentage}
              projectMargin={projectMargin}
              handleProjectPercentage={() => {}}
              handleContigencyPercentage={() => {}}
              handleAttached={() => {}}
              handleOpen={() => {}}
              handleBillableChange={() => {}}
              handleBillableBlur={() => {}}
              GST={GST}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Pricing Sections  Ends*/}

      {/* Terms Sections Starts */}
      <Grid size={12}>
        <h2 className="mt-4 mb-3">Term & Condition</h2>
        <Grid container spacing={2}>
          <Grid size={12}>
            <h6 className="quote-form-label">{'Standard Terms & Condition'}</h6>
            <StandardTermsStep
              terms={termsList}
              currentStandardTermsList={currentStandardTermsList}
            />
          </Grid>
          <Grid size={12}>
            <h6 className="quote-form-label">{'Adhoc Terms & Condition'}</h6>
            <List>
              {selectedAdhocTerms.map((item, index) => {
                return (
                  <ListItem
                    sx={{
                      display: 'list-item',
                      listStyle: 'disc',
                    }}
                    key={'terms_list_' + index}
                  >
                    <ListItemText>{item.termText}</ListItemText>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
          <Grid size={12}>
            <h6 className="quote-form-label">{'Billable Exclusion'}</h6>
            <List>
              {selectedExclusions.map((item, index) => {
                return item.exclusion ? (
                  <ListItem
                    sx={{
                      display: 'list-item',
                    }}
                    key={'billable_exclusion_name_list_' + index}
                  >
                    <ListItemText sx={{ fontWeight: 'bold' }}>
                      {item.name}
                    </ListItemText>
                    <ListItem
                      sx={{
                        display: 'inline-flex',
                      }}
                      key={'billable_exclusion_list_' + index}
                    >
                      <ListItemText sx={{ fontWeight: 'bold' }}>
                        {item.exclusion}
                      </ListItemText>
                    </ListItem>
                  </ListItem>
                ) : (
                  <span></span>
                );
              })}
            </List>
          </Grid>
          <Grid size={12}>
            <h6 className="quote-form-label">
              {'Quote Inclusion & Exclusion'}
            </h6>
            <List>
              <ListItem
                sx={{
                  display: 'list-item',
                  width: '350px',
                }}
                key={'quote_inclusion_name_list_'}
              >
                <ListItemText sx={{ fontWeight: 'bold' }}>
                  Quote Inclusions
                </ListItemText>
                {selectedQuoteInclusion && (
                  <ListItem
                    sx={{
                      display: 'inline-flex',
                    }}
                    key={'quote_inclusion_list_'}
                  >
                    <ListItemText sx={{ fontWeight: 'bold' }}>
                      {selectedQuoteInclusion}
                    </ListItemText>
                  </ListItem>
                )}
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  width: '350px',
                }}
                key={'quote_exclusion_name_list_'}
              >
                <ListItemText sx={{ fontWeight: 'bold' }}>
                  Quote Exclusions
                </ListItemText>
                {selectedQuoteExclusion && (
                  <ListItem
                    sx={{
                      display: 'inline-flex',
                    }}
                    key={'quote_exclusion_list_'}
                  >
                    <ListItemText sx={{ fontWeight: 'bold' }}>
                      {selectedQuoteExclusion}
                    </ListItemText>
                  </ListItem>
                )}
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Grid>
      {/* Terms Sections Ends */}
    </Grid>
  );
};
export default ReviewFinalStep;
